import { Routes } from '@angular/router';
import { CancellationsDashboard } from './molecules/cancellations-dashboard/cancellations-dashboard';
import { CancellationsResponses } from './molecules/cancellations-responses/cancellations-responses';

export const adminCancellationsRoutes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: CancellationsDashboard },
  { path: 'responses', component: CancellationsResponses },
];
